import { useNavigation } from '@react-navigation/native';
import { fontSizes } from '_/config/theme';
import { images } from '_/space-management/assets';
import { Button, Text } from '_/space-management/components';
import { colors, spacing } from '_/space-management/constants/theme';
import { AppRoute } from '_/space-management/navigation/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image, StyleSheet, Dimensions } from 'react-native';

export default function NoReservation() {
  const navigation = useNavigation<any>();
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Image source={images.denied} style={styles.image} />
      <Text fontType="medium" fontSize={fontSizes.md2}>
        {t('spaceManage.reservationsScreen.noReservationsMessage')}
      </Text>
      <Text fontType="medium" fontSize={fontSizes.md2}>
        {t('spaceManage.reservationsScreen.seeLocationsMessage')}
      </Text>
      <Button
        backgroundColor={colors.lightBlue}
        textColor={colors.white}
        style={styles.button}
        onPress={() => navigation.navigate(AppRoute.HOME)}
      >
        {t('spaceManage.reservationsScreen.seeLocations')}
      </Button>
    </View>
  );
}

const { height } = Dimensions.get('window');

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginTop: height * 0.25 + 32,
    marginBottom: 60,
    paddingHorizontal: spacing.md,
  },
  image: {
    height: 87,
    width: 87,
    marginBottom: spacing.md,
  },
  button: {
    marginTop: 60,
  },
});
